import { configureStore } from '@reduxjs/toolkit'
import permissionReducer from "./features/PermissionSlice";
import sessionReducer from "./features/SessionSlice"
import alertReducer from "./features/AlertSlice";
import projectReducer from "./features/ProjectsSlice";

export default configureStore({
    reducer: {
        permissions: permissionReducer,
        session: sessionReducer,
        alert: alertReducer,
        projects: projectReducer,
    }
})
